import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import trans from 'counterpart'
import isEqual from 'lodash.isequal'
import { replaceStateVariables } from '../utilities'

class RichText extends Component {
  static propTypes = {
    value: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    updatedValue: PropTypes.string
  };

  /**
   * Make sure this component is only updated when the value changed
   *
   * @param {object} nextProps
   */
  shouldComponentUpdate = (nextProps) => {
    if (!isEqual(nextProps.updatedValue, this.props.updatedValue)) {
      return true
    }

    return false
  }

  decodeHtml = (html) => {
    // TODO: Validate & decode on backend
    if (typeof document !== 'undefined') {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    }

    return html
  }

  // Replace matches with Link components
  replaceLinks = (match, propsBefore, path, propsAfter, text) => {
    if (path.startsWith('/')) {
      return `<a ${propsBefore} href=${path} hrefLang="${trans('locale')}">${text}</a>`
    }

    return match
  }

  render () {
    const { updatedValue, ...restProps } = this.props

    let html = this.decodeHtml(updatedValue)
    // This is here for backwards compatibility. Some img sources are still defined as relative paths,
    // while they should now be mapped to the api.
    html = html.replace(/"\/media\/cache\/resolve/g, `"${process.env.RAZZLE_API_BASE_URL}/media/cache/resolve`)

    // Replace Links in html with <Link> components
    html = html.replace(/<a(.*)href="(.*)"(.*)>(.*)<\/a>/g, this.replaceLinks)

    return (
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        {...restProps}
      />
    )
  }
}

export default connect(
  (state, ownProps) => ({
    // Replace variables defined in the value with the state var
    updatedValue: replaceStateVariables(ownProps.value, state)
  })
)(RichText)
